export const FETCH_CREATE_LABEL = 'FETCH_CREATE_LABEL';
export const FETCH_UPDATE_LABEL = 'FETCH_UPDATE_LABEL';
export const FETCH_DELETE_LABEL = 'FETCH_DELETE_LABEL';
export const FETCH_GET_ALL_LABELS = 'FETCH_GET_ALL_LABELS';

export const FETCH_TASK_ADD_LABEL = 'FETCH_ADD_LABEL';
export const FETCH_TASK_REMOVE_LABEL = 'FETCH_TASK_REMOVE_LABEL';
